















































































































import { Vue, Component, Emit, Watch, Ref } from 'vue-property-decorator'
import ServerError from '@/utils/server_error'
import { MemberAPI } from '@/api/member'
import { getModule } from 'vuex-module-decorators'
import sharedStore from '@/modules/shared/shared.store'
import { SupportedAvatar } from '@/api/config'

@Component
export default class CompleteUserProfileDetails extends Vue {
  sharedModule = getModule(sharedStore, this.$store)

  @Ref('birthdayPicker')
  readonly birthdayPicker!: any

  rules: any = {}
  form: {
    birthDate?: number
    avatar?: string
  } = {
    birthDate: undefined,
    avatar: undefined
  }
  dateMax = this.$moment().format('YYYY-MM-DD')
  validate = false
  loading = false
  menu = false

  /* Computed Properties */
  get avatarOptions(): SupportedAvatar[] {
    return this.sharedModule.applicationSupportedAvatars
  }

  /* Watchers */
  @Watch('menu')
  onMenuUpdated(val: boolean) {
    if (val) {
      setTimeout(() => {
        this.birthdayPicker.activePicker = 'YEAR'
      })
    }
  }

  /* Hooks */
  created() {
    this.rules['nickname'] = [
      (v: any) => !!v || this.$t('RegistrationForm.UsernameIsRequired'),
      (v: any) =>
        (v && v.length >= 6) ||
        this.$t('RegistrationForm.UsernameMustHaveAtLeast6Characters')
    ]
  }

  mounted() {
    // initialize icon
    if (this.avatarOptions) {
      this.form.avatar = this.avatarOptions[0].url
    }
  }

  /* Methods */
  async onSubmit() {
    this.loading = true

    try {
      await MemberAPI.editProfile({
        birthDate: this.$moment(this.form.birthDate).unix(),
        avatar: this.form.avatar
      })
      this.next()
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error('System error. Please try again later')
      }
      console.error(err)
    } finally {
      this.loading = false
    }
  }

  reset() {
    this.form = {
      birthDate: undefined
    }
  }

  @Emit('next')
  next() {}
}
